export const colors = ["#D6A300", "#F5F5F5"]